import AmbientWaveformBackground from './ambient-waveform-background'
import LandingFounderPricing from './landing-founder-pricing'
import LandingHeroLaunch from './landing-hero-launch'

export default function LandingPageLaunch() {
	return (
		<main className="text-base-content font-poppins flex min-h-screen flex-col bg-gradient-to-b from-background via-indigo-500/5 to-purple-500/10">
			<AmbientWaveformBackground />
			<div className="relative z-10 flex flex-col">
				<LandingHeroLaunch />
				<LandingFounderPricing />
			</div>
		</main>
	)
}
